import axios from "axios";

export const axiosClient = axios.create({
  baseURL: process.env.API_URL,
  headers: {
    "ngrok-skip-browser-warning": "true"
  }
});

export const CORS_ERROR_KEY = 'voa_cors_error';

axiosClient.interceptors.response.use((response) => response, (error) => {
  if (typeof error.response === 'undefined') {
    const obj = {
      [error.config.url]: Date.now(),
    }
    localStorage.setItem(CORS_ERROR_KEY, JSON.stringify(obj));
  }
  return Promise.reject(error)
});

axiosClient.interceptors.request.use((config) => {
  localStorage.removeItem(CORS_ERROR_KEY);
  return config;
}, (error) => {
  return Promise.reject(error);
});
